import React, { useState } from "react";

const Settings = () => {
  const [copied, setCopied] = useState(false);
  const email = "toincoss2025@gmail.com";

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="settingsTwo">
      <h3>Settings</h3>
      <div className="email-copy">
        <span>{email}</span>
        <button onClick={handleCopy}>Copy</button>
      </div>
      {copied && <p className="copied-message">Email copied to clipboard!</p>}
    </div>
  );
};

export default Settings;

